import { connect } from 'react-redux';

import FilesDndUploader from '../../../components/ImportDesktopFile/FilesDndUploader';

export default connect()(FilesDndUploader);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/FilesDndUploader/index.tsx